module.exports = __webpack_public_path__ + "static/homepage_image1-35b0ae6671bc7eb5b0ee11d25e067eda.png";